import React, { useState } from 'react';

import './nav-sub-menu.scss'
import NavSectionSubMenu from '../nav-section-sub-menu/nav-section-sub-menu';

const NavSubMenu = props => {

    const [activeColapse, setColapse] = useState(0);

    if(props.activeSubMenu === 2){
        if(!props.mobile){
            return (
                <div onClick={e => props.stopProp(e)} className="f-dropdown-menu-2">
                    <span className="top-shadow"></span>
                    <div className="f-close-colapse" onClick={() => props.setSubMenu(1)}></div>
                    {props.navSubMenuTitles2.map((item,index) =>{
                                return(
                                    <NavSectionSubMenu 
                                        titles={item.enlaceTituloSubmenu}
                                        sections={item.enlaceContenidoSubmenu}
                                        isPink={index % 2 === 0}
                                        mobile={props.mobile}
                                        key={index}
                                        identify={index}
                                        activeSubMenu={props.activeSubMenu}
                                    />
                                )
                            }
                        )
                    }

                </div>
            )
        }else{//Mobile
            return (
                <>
                    <span className="f-list-separator"/>
                    <ul className="f-list-sub-menu-container-mobile">
                        {props.navSubMenuTitles2.map((item,index) =>{
                                    return(
                                        <NavSectionSubMenu 
                                            titles={item.enlaceTituloSubmenu}
                                            sections={item.enlaceContenidoSubmenu}
                                            mobile={props.mobile}
                                            key={index}
                                            identify={index}
                                            activeSubMenu={props.activeSubMenu}

                                            activeColapse={activeColapse}
                                            setColapse={setColapse}
                                        />
                                    )
                                }
                            )
                        }
                    </ul>
                </>
            )
        }
    }else if(props.activeSubMenu === 3){
        if(!props.mobile){
            return (
                <div onClick={e => props.stopProp(e)} className="f-dropdown-menu-3">
                    <span className="top-shadow"></span>
                    <div className="f-close-colapse" onClick={() => props.setSubMenu(1)}></div>

                    {props.navSubMenuTitles3.map((item,index) =>{

                                return(
                                    <NavSectionSubMenu 
                                        titles={item.enlaceTituloSubmenu}
                                        sections={item.enlaceContenidoSubmenu}
                                        isPink={index % 2 === 0}
                                        mobile={props.mobile}
                                        key={index}
                                        identify={index}
                                        activeSubMenu={props.activeSubMenu}
                                    />
                                )
                            }
                        )
                    }

                </div>
            )
        }else{//Mobile
            return (
                <>
                    <span className="f-list-separator"/>
                    <ul className="f-list-sub-menu-container-mobile">
                        {props.navSubMenuTitles3.map((item,index) =>{

                                    return(
                                        <NavSectionSubMenu 
                                            titles={item.enlaceTituloSubmenu}
                                            sections={item.enlaceContenidoSubmenu}
                                            mobile={props.mobile}
                                            key={index}
                                            identify={index}
                                            activeSubMenu={props.activeSubMenu}
                                            activeColapse={activeColapse}
                                            setColapse={setColapse}
                                        />
                                    )
                                }
                            )
                        }
                    </ul>
                </>
            )
        }
    }else if(props.activeSubMenu === 5){
        if(!props.mobile){
            return (
                <div onClick={e => props.stopProp(e)} className="f-dropdown-menu-5">
                    <span className="top-shadow"></span>
                    <div className="f-close-colapse" onClick={() => props.setSubMenu(1)}></div>

                    {props.navSubMenuTitles5.map((item,index) =>{

                                return(
                                    <NavSectionSubMenu 
                                        titles={item.enlaceTituloSubmenu}
                                        sections={item.enlaceContenidoSubmenu}
                                        isPink={index % 2 === 0}
                                        mobile={props.mobile}
                                        key={index}
                                        identify={index}
                                        activeSubMenu={props.activeSubMenu}
                                    />
                                )
                            }
                        )
                    }

                </div>
            )
        }else{//Mobile
            return (
                <>
                    <span className="f-list-separator"/>
                    <ul className="f-list-sub-menu-container-mobile">
                        {props.navSubMenuTitles5.map((item,index) =>{

                                    return(
                                        <NavSectionSubMenu 
                                            titles={item.enlaceTituloSubmenu}
                                            sections={item.enlaceContenidoSubmenu}
                                            mobile={props.mobile}
                                            key={index}
                                            identify={index}
                                            activeSubMenu={props.activeSubMenu}
                                            activeColapse={activeColapse}
                                            setColapse={setColapse}
                                        />
                                    )
                                }
                            )
                        }
                    </ul>
                </>
            )
        }
    }else{
        return null
    }
}

export default NavSubMenu
